import "../../js/core";
import "./page-home.scss";
import "../../../assets/src/eos/js/video-youtube-iframe";
import "../../components/site-elements/sliders/slider-card-blog/slider-card-blog";
import setBlogSubscribeModalHandlers from "../../../assets/src/eos/js/modals/setBlogSubscribeModalHandlers";
import "../../components/site-elements/sliders/slider-video/slider-video";

$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      $(".slider-stories").owlCarousel({
        responsive: {
          0: {
            items: 2,
            dots: false,
            nav: false,
            loop: true,
          },
          768: {
            items: 3,
          },
          1241: {
            items: 4,
          },
        },
        loop: false,
        nav: true,
        dots: true,
        slideBy: 1,
        margin: 20,
        smartSpeed: 200,
      });

      $(".slider-card-blog").owlCarousel({
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          992: {
            items: 3,
          },
        },
        loop: true,
        nav: true,
        dots: false,
        slideBy: 1,
        margin: 20,
        smartSpeed: 200,
      });

      $(".slider-card-membership").owlCarousel({
        responsive: {
          0: {
            items: 1,
          },
          568: {
            items: 2,
          },
          1241: {
            items: 3,
          },
          1441: {
            items: 4,
          },
        },
        nav: true,
        dots: false,
        dotsEach: false,
        margin: 20,
        smartSpeed: 200,
      });

      $(".slider-card-partners").owlCarousel({
        responsive: {
          0: {
            items: 2,
          },
          480: {
            items: 3,
          },
          640: {
            items: 4,
          },
          900: {
            items: 5,
          },
          1241: {
            items: 6,
          },
          1441: {
            items: 7,
          },
        },
        slideBy: 1,
        dots: false,
        nav: true,
        loop: false,
        margin: 20,
        smartSpeed: 200,
      });

      $(".owl-carousel").each(function (index) {
        $(this)
          .find(".owl-nav, .owl-dots")
          .wrapAll("<div class='owl-controls'></div>");
      });
    });
  });
});

setBlogSubscribeModalHandlers("#modalSubscribeSent");
